import { SessionEventsService } from './core/services/auth/session-events.service';
import { Component, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { installAvatarFallback } from './core/util/avatar-fallback/avatar-fallback.util';
import { Title } from '@angular/platform-browser';
import { CsrfService, MaintenanceService, MaintenanceMode } from './core/services';
import { ChunkReloadNavigationService } from './core/services/chunk-reload/chunk-reload';
import { ThemeService } from './core/services/theme/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'schnapsen.online-frontend';
  maintenanceMode: MaintenanceMode = 'none';
  private originalTitle = 'schnapsen.online';

  constructor(
    private csrfService: CsrfService,
    private sessionEvents: SessionEventsService,
    private maintenanceService: MaintenanceService,
    private titleService: Title
  ) {
    // Broken/missing profile pictures anywhere in the app fall back to the default avatar.
    installAvatarFallback(inject(DOCUMENT));
    // A tab from before a deploy reloads once when a lazy area of the old build is gone.
    inject(ChunkReloadNavigationService).start();
    // light/dark choice of this device
    inject(ThemeService);

    this.maintenanceService.maintenanceMode$.subscribe((mode) => {
      this.maintenanceMode = mode;
      this.updateBrowserTitle(mode);
    });


  }

  get showMaintenancePage(): boolean {
    return this.maintenanceService.shouldShowMaintenancePage();
  }


  get showNormalApp(): boolean {
    return !this.showMaintenancePage;
  }

  private updateBrowserTitle(maintenanceMode: MaintenanceMode) {
    if (maintenanceMode === 'planned') {
      this.titleService.setTitle('🔧 Wartung - schnapsen.online');
    } else if (maintenanceMode === 'server_error') {
      this.titleService.setTitle('⚠️ Serverfehler - schnapsen.online');
    } else {
      this.titleService.setTitle(this.originalTitle);
    }
  }
}
